module.exports = __webpack_public_path__ + "media/images/game_icon/vi/AB1015-94dc46421c4a5cdad2300b629f605711.png";